import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-notice\">\n    <path d=\"M121.807 224.76a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0 27.674a2.606 2.606 0 0 1-2.518-2.687h5.035a2.606 2.606 0 0 1-2.517 2.687zm-10.9-4.988 2.664-3.2V239.3a8.666 8.666 0 0 1 6.92-8.668c0-.041-.011-.081-.011-.124a1.332 1.332 0 1 1 2.658 0c0 .043-.009.083-.012.124a8.665 8.665 0 0 1 6.92 8.668v4.947l2.664 3.2z\" transform=\"translate(-105.807 -224.76)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol